import React from 'react';
import { useNavigate } from 'react-router-dom';

const DOELEN = [
  { key: 'beregening', label: 'Beregening', omschrijving: 'Agrarische beregening, sportvelden, tuinberegening, openbaar groen, parken, recreatie, golfbanen', actief: true, route: '/beregening' },
  { key: 'bronbemaling', label: 'Bronbemaling', omschrijving: 'Tijdelijke grondwateronttrekking bij bouwprojecten', actief: false },
  { key: 'drainage', label: 'Drainage', omschrijving: 'Drainage-trajecten', actief: false },
  { key: 'brandblusvoorzieningen', label: 'Brandblusvoorzieningen', omschrijving: 'Registratie van brandblusbronnen', actief: false },
  { key: 'sanering', label: 'Grondwatersanering', omschrijving: 'Sanerings-projecten en bijbehorende monitoring', actief: false },
  { key: 'veedrenkputten', label: 'Veedrenkputten', omschrijving: 'Putten voor veedrenking', actief: false },
  { key: 'overig', label: 'Overige onttrekkingen', omschrijving: 'Overige grondwateronttrekkingen', actief: false },
];

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div className="landing">
      <div className="landing-inner">
        <header className="landing-header">
          <h1 className="landing-title">Grondwaterregister</h1>
          <p className="landing-subtitle">Waterschap Brabantse Delta</p>
        </header>

        <div className="landing-grid">
          {DOELEN.map(d => (
            <button
              key={d.key}
              className={`landing-tegel ${d.actief ? '' : 'landing-tegel-dim'}`}
              onClick={() => d.actief && navigate(d.route)}
              disabled={!d.actief}
              aria-disabled={!d.actief}
              title={d.actief ? `Ga naar ${d.label}` : `${d.label} — in ontwerp`}
            >
              <div className="landing-tegel-titel">{d.label}</div>
              <div className="landing-tegel-omschrijving">{d.omschrijving}</div>
              {!d.actief && <div className="landing-tegel-badge">in ontwerp</div>}
            </button>
          ))}
        </div>

      </div>
    </div>
  );
}
